import React, { useEffect, useRef, useState } from "react";
import MappingTopBox from "./components/MappingTopBox";
import { observer } from "mobx-react";
import LoadingAnimation from "../../../components/ui/utils/LoadingAnimation";
import getMappingToolStore from "./data/MappingToolStore";
import MappingTicSheetTable from "./components/MappingTicSheetTable";
import TopMostPortal from "../../../components/ui/utils/Portals";
import { getMappingStore } from "./utils/MappingUtils";
import { AzureFormResult, AzureRead, AzureResults, Cell, DocumentWord, TemplateCellTuple } from "../../../shared/common/Azure";
import { logDebug } from "../../../shared/common/logger";
import SharedUtils from "../../../shared/common/SharedUtils";
import { doc, setDoc } from "firebase/firestore";
import { useFirestore, useFirestoreDocData } from "reactfire";
import PrivateUtils from "../../../utils/PrivateUtils";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { selectablesMap } from "../../../shared/common/EstimateEngine/TicSelectables";
import MappingTicTypeSelector from "./components/MappingTicTypeSelector";

interface ITableData {
	input: string[];
	output: string;
	isError?: boolean;
}
const TestDataTable: React.FC<{ type: string; selectedTupple: TemplateCellTuple }> = observer(({ selectedTupple, type }) => {
	const mappingToolStore = getMappingToolStore();
	const tuppleId = selectedTupple.meta?.id!;
	const metaDataSubPath = SharedUtils.getDbPath(`tools/new_TestDataTable${type === "Type1" ? "" : type}/`);
	const firestoreToolsDocRef = doc(useFirestore(), metaDataSubPath);
	const testDataTableDataBase = useFirestoreDocData<any>(firestoreToolsDocRef, { idField: "id" });
	const renderedSet = useRef(new Set<string>());
	const [tableData, setTableData] = useState<ITableData[]>([]);
	const [timeoutRef, setTimeoutRef] = useState<any>();
	useEffect(() => {
		if (testDataTableDataBase.data && tableData.length === 0) {
			setTableData(testDataTableDataBase.data[tuppleId] || []);
		}
		return () => {
			if (timeoutRef) {
				clearTimeout(timeoutRef);
			}
		};
	}, [testDataTableDataBase.data]);

	if (testDataTableDataBase.status === "loading") {
		return <div>Loading...</div>;
	}
	// logDebug('testDataTableDataBase', testDataTableDataBase.data, tableData);

	function saveData(data: ITableData[]) {
		setDoc(
			firestoreToolsDocRef,
			{
				[tuppleId]: data,
			},
			{ merge: true }
		);
	}

	function addEntry() {
		const newData = [
			...tableData,
			{
				input: ["", "", ""],
				output: "",
			},
		];
		saveData(newData);
		setTableData(newData);
	}

	function saveDataWithDelay() {
		if (timeoutRef) {
			clearTimeout(timeoutRef);
		}
		setTimeoutRef(
			setTimeout(
				() => {
					saveData(tableData);
					setTimeoutRef(null);
				},
				location.href.includes("localhost") ? 1000 : 5000
			)
		);
	}
	if (selectedTupple.meta!.heatmapData && selectedTupple.meta!.heatmapData.length > 0) {
		const td = getMappingStore().templateData;
		// logDebug('hm1', SharedUtils.clone(selectedTupple));
	}

	return (
		<div className="h-full w-full bg-red-200 flex flex">
			<div className="w-[50%]">
				<div className="flex">
					<button
						onClick={() => {
							mappingToolStore.selectedTuple = [-1, -1];
						}}
						className="border bg-sky-100 rounded-lg m-2 p-2"
					>
						Close
					</button>
					<button onClick={addEntry} className="border bg-sky-100 rounded-lg m-2 p-2">
						Add Entry
					</button>
					{timeoutRef && <button className="border bg-pink-100 rounded-lg m-2 p-2">Saving...</button>}
				</div>
				{tableData.map((data, index) => {
					return (
						<div key={index} className="border border-green-400 m-2 p-2">
							<div className="px-2 flex">
								L:
								<input
									className="border mx-1 w-[30%]"
									value={data.input[0]}
									onChange={(e) => {
										const newData = [...tableData];
										newData[index].input[0] = e.target.value;
										setTableData(newData);
									}}
									onBlur={() => {
										saveDataWithDelay();
									}}
								/>
								R:
								<input
									className="border mx-1 w-[30%]"
									value={data.input[1]}
									onChange={(e) => {
										const newData = [...tableData];
										newData[index].input[1] = e.target.value;
										setTableData(newData);
									}}
									onBlur={() => {
										saveDataWithDelay();
									}}
								/>
								S:
								<input
									className="border mx-1 w-[30%]"
									value={data.input[2]}
									onChange={(e) => {
										const newData = [...tableData];
										newData[index].input[2] = e.target.value;
										setTableData(newData);
									}}
									onBlur={() => {
										saveDataWithDelay();
									}}
								/>
								Err:
								<input
									type="checkbox"
									className="border mx-1"
									checked={data.isError}
									onChange={(e) => {
										const newData = [...tableData];
										newData[index].isError = e.target.checked;
										setTableData(newData);
									}}
									onBlur={() => {
										saveDataWithDelay();
									}}
								/>
								<button
									onClick={() => {
										const newData = [...tableData];
										newData.splice(index, 1);
										saveData(newData);
										setTableData(newData);
										setTimeout(() => {
											saveDataWithDelay();
										}, 100);
									}}
									className="border bg-red-500 rounded-lg px-2"
								>
									X
								</button>
							</div>
							<div className="px-1 mt-1 flex items-start w-full">
								O:
								<textarea
									readOnly={true}
									className="border mx-1 w-full"
									value={JSON.stringify(data.output)}
									// onChange={(e) => {
									// 	const newData = [...tableData];
									// 	newData[index].output = e.target.value;
									// 	setTableData(newData);
									// }}
									// onBlur={() => {
									// 	saveDataWithDelay();
									// }}
								></textarea>
							</div>
						</div>
					);
				})}
			</div>
			<div className="w-[50%] overflow-y-auto mt-4">
				{selectedTupple.meta?.heatmapData?.map((data, index) => {
					if (index == 0) {
						renderedSet.current.clear();
						// logDebug('data', SharedUtils.clone(data));
					}
					const key = data.azure
						.join(" ")
						.replace(":selected:", "")
						.replace(/\s+/g, " ")
						.replace(/\d+/g, "{N}")
						.split(" ")
						.join(" ");
					if (renderedSet.current.has(key)) {
						// logDebug('skipping', key);
						return null;
					}
					renderedSet.current.add(key);
					return (
						<div className="bg-sky-100">
							<div>{key}</div>
							<img
								key={index}
								src={`data:image/png;base64,${data.region64}`}
								alt="heatmap"
								className="w-full max-h-32 my-0.5 border"
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
});

interface IRenderItem {
	s: string;
	top: number;
	left: number;
	width: number;
	height: number;
}

enum EUseIndex {
	ErrorOnly = -3,
	Last = -2,
	Random = -1,
	First = 0,
}

const TicSheetTableFilled: React.FC<{ type: string; onClose: () => void; useIndex: number }> = observer(({ onClose, useIndex, type }) => {
	const mappingStore = getMappingStore();
	const metaDataSubPath = SharedUtils.getDbPath(`tools/new_TestDataTable${type === "Type1" ? "" : type}/`);
	const firestoreToolsDocRef = doc(useFirestore(), metaDataSubPath);
	const testDataTableDataBase = useFirestoreDocData<{ [key: string]: ITableData[] }>(firestoreToolsDocRef);
	const [renderedList, setRenderList] = useState<IRenderItem[]>([]);
	const [exportingPDF, setExportingPDF] = useState(false);

	// logDebug('useIndex', useIndex);
	useEffect(() => {
		const _renderedList: IRenderItem[] = [];
		if (testDataTableDataBase.status !== "success") {
			return;
		}
		logDebug("testDataTableDataBase", testDataTableDataBase.data);
		Object.entries(testDataTableDataBase.data).forEach(([key, values]) => {
			if ("NO_ID_FIELD" === key) return;

			const cellInTemplate = findKeyInTemplateData(key);
			if (!cellInTemplate) {
				logDebug("key not found", key);
				return;
			}
			let _useIndex = 0; //Math.floor(Math.random() * values.length);
			if (useIndex === EUseIndex.Random) {
				_useIndex = Math.floor(Math.random() * values.length);
			} else if (useIndex === EUseIndex.Last) {
				_useIndex = values.length - 1;
			} else if (useIndex === EUseIndex.ErrorOnly) {
				values = values.filter((value) => value.isError);
				if (values.length > 0) {
					_useIndex = Math.floor(Math.random() * values.length);
				} else {
					return;
				}
				// useIndex = values.findIndex((value) => value.output.includes('error'));
			} else if (useIndex >= 0 && useIndex < values.length) {
				_useIndex = useIndex;
			} else {
				return;
			}
			// logDebug('useIndex2', values, useIndex, values[_useIndex]);
			if (cellInTemplate.cell) {
				const polygon0 = cellInTemplate.cell.cells[0].cellRef.boundingRegions[0].polygon;
				_renderedList.push({
					s: values[_useIndex].input[0],
					top: polygon0[0].y,
					left: polygon0[0].x,
					width: polygon0[1].x - polygon0[0].x,
					height: polygon0[2].y - polygon0[0].y,
				});
				const polygon1 = cellInTemplate.cell.cells[1]?.cellRef.boundingRegions[0].polygon || [{x: 0, y: 0}, {x: 0, y: 0}, {x: 0, y: 0}];
				_renderedList.push({
					s: values[_useIndex].input[1],
					top: polygon1[0].y,
					left: polygon1[0].x,
					width: polygon1[1].x - polygon1[0].x,
					height: polygon1[2].y - polygon1[0].y,
				});
			}
			const wanted0 = values[_useIndex].input[2].split(",").map((word) => `(${word.trim().toLowerCase()})`.replace(/\s+/g, " "));
			const wanted1 = values[_useIndex].input[2].split(",").map((word) => `${word.trim().toLowerCase()}`.replace(/\s+/g, " "));
			const wanted = [...wanted0, ...wanted1];
			// logDebug('wanted', wanted, cellInTemplate.selectables);
			const found = cellInTemplate.selectables.filter((word) => wanted.includes(word.content!.toLowerCase()));

			if (wanted.length) {
				logDebug("cellInTemplate", cellInTemplate);
				logDebug("wanted", wanted, cellInTemplate.selectables, "found", found);
			}

			found.forEach((word) => {
				_renderedList.push({
					s: "~",
					top: word.polygon[0].y,
					left: word.polygon[0].x,
					width: word.polygon[1].x - word.polygon[0].x + 3,
					height: word.polygon[2].y - word.polygon[0].y,
				});
			});

			// logDebug('key!!', SharedUtils.clone(cellInTemplate), values[randomIndex]);
		});
		setRenderList(_renderedList);
	}, [testDataTableDataBase.data]);

	if (testDataTableDataBase.status === "loading") {
		return <div>Loading...</div>;
	}

	function _findSelectableWordsInTemplateCell(azureResults: AzureFormResult, cell: Cell, selectables: string[]): DocumentWord[] {
		const maybeSelectableWords: DocumentWord[] = [];
		const span = cell.spans[0];
		if (!span) {
			return [];
		}
		logDebug("span", cell);
		azureResults.pages[0].words.forEach((word) => {
			if (word.span.offset >= span.offset && word.span.offset + word.span.length <= span.offset + span.length) {
				if (
					word.content?.includes("(") ||
					word.content?.includes(")") ||
					selectables.includes((word.content ?? "====").toLowerCase()) ||
					selectables.includes(`(${(word.content ?? "====").toLowerCase()})`)
				) {
					maybeSelectableWords.push(SharedUtils.clone(word));
				}
			}
		});
		for (let i = 0; i < maybeSelectableWords.length - 1; ) {
			if (
				maybeSelectableWords[i] &&
				maybeSelectableWords[i].content?.includes("(") &&
				!maybeSelectableWords[i].content?.includes(")") &&
				maybeSelectableWords[i + 1].content?.includes(")")
			) {
				maybeSelectableWords[i].content += " " + maybeSelectableWords[i + 1].content!;
				maybeSelectableWords[i].polygon[1].x = maybeSelectableWords[i + 1].polygon[1].x;
				maybeSelectableWords[i].polygon[2].x = maybeSelectableWords[i + 1].polygon[2].x;
				maybeSelectableWords[i + 1].content = "";
				i += 2;
			} else {
				i++;
			}
		}
		logDebug(
			"maybeSelectableWords",
			maybeSelectableWords.filter((word) => word.content)
		);
		return maybeSelectableWords.filter((word) => word.content);
	}

	// logDebug('testDataTableDataBase', testDataTableDataBase.data);
	function findKeyInTemplateData(key: string) {
		if (key === "simulated_header_debris_pickup_tandem_dump_dump_truck_dumpster_12_20_30_40") {
			const debrisSelectables = [
				{ content: "pickup", x: 763, y: 130, w: 72, h: 20 },
				{ content: "Tandem Dump", x: 763, y: 130, w: 72, h: 20 },
				{ content: "Dump Truck", x: 763, y: 130, w: 72, h: 20 },
				{ content: "Dumpster", x: 663, y: 158, w: 96, h: 22 },
				{ content: "12", x: 766, y: 158, w: 38, h: 24 },
				{ content: "(20)", x: 825, y: 158, w: 38, h: 24 },
				{ content: "(30)", x: 877, y: 158, w: 38, h: 24 },
				{ content: "(40)", x: 930, y: 158, w: 38, h: 24 },
			];
			return {
				cell: undefined,
				selectables: debrisSelectables.map((s) => ({
					confidence: 1,
					span: { offset: 0, length: 6 },
					content: s.content,
					polygon: [
						{ x: s.x, y: s.y },
						{ x: s.x + s.w, y: s.y },
						{ x: s.x + s.w, y: s.y + s.h },
						{ x: s.x, y: s.y + s.h },
					],
				})) as DocumentWord[],
				// 'PickUp,', 'Tandem', 'Truck,', 'Dumpster', '(12)', '(20)', '(30)', '(40)'
			};
		}
		for (let i = 0; i < mappingStore.templateData!.rows!.length; i++) {
			const row = mappingStore.templateData!.rows![i];
			for (let j = 0; j < row.cellTuples.length; j++) {
				const cell = row.cellTuples[j];

				if (cell.meta?.id === key) {
					return {
						cell,
						selectables: selectablesMap[key]
							? _findSelectableWordsInTemplateCell(
									mappingStore.templateData!.azureOriginal!,
									cell.cells[0].cellRef,
									selectablesMap[key]
							  )
							: _findSelectableWordsInTemplateCell(
									mappingStore.templateData!.azureOriginal!,
									cell.cells[0].cellRef,
									cell.meta?.selectables || []
							  ),
					};
				}
			}
		}
		return null;
	}

	async function exportPDFElements(
		element: HTMLElement[],
		_props?: {
			outname?: string;
			orientation?: "landscape" | "portrait";
		}
	) {
		return new Promise<void>((resolve, reject) => {
			setTimeout(async () => {
				try {
					const canvases: HTMLCanvasElement[] = await Promise.all(
						element.map(async (element) => {
							// Get computed styles to ensure all styles are considered
							logDebug("getting getComputedStyle");
							const computedStyle = window.getComputedStyle(element);

							// Log relevant computed styles for debugging
							logDebug(
								"Computed Style",
								JSON.stringify({
									height: computedStyle.height,
									paddingTop: computedStyle.paddingTop,
									paddingBottom: computedStyle.paddingBottom,
									marginTop: computedStyle.marginTop,
									marginBottom: computedStyle.marginBottom,
									borderTopWidth: computedStyle.borderTopWidth,
									borderBottomWidth: computedStyle.borderBottomWidth,
								})
							);

							logDebug("element.scrollHeight", element.scrollHeight);
							element.style.height = `${element.scrollHeight}px`;
							const canvas = await html2canvas(element, { scale: 1 });
							element.style.height = "";
							logDebug("canvas.height", canvas.height);
							return canvas;
						})
					);
					const props = {
						orientation: _props?.orientation || "landscape",
						unit: "px",
						format: [
							canvases.reduce((acc, canvas) => acc + canvas.height, 0),
							canvases.reduce((acc, canvas) => (canvas.width > acc ? canvas.width : acc), 0) + 200,
						],
					};
					logDebug("pdf props", JSON.stringify(props));
					const pdf = new jsPDF(props as any);
					let accuHeight = 0;
					canvases.forEach((canvas, index) => {
						const imgData = canvas.toDataURL("image/png");
						// logDebug(index, 'imgData', imgData)
						logDebug(`adding to canva ${index}`, accuHeight, canvas.width, canvas.height);
						pdf.addImage(imgData, "PNG", 100, accuHeight, canvas.width, canvas.height);
						accuHeight += canvas.height;
					});

					pdf.save(`${_props?.outname || Date.now()}.pdf`);
					resolve();
				} catch (err) {
					reject(err);
				}
			}, 30);
		});
	}

	// logDebug("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", mappingStore.templateData);
	// for (let i = 0; i < mappingStore.templateData!.rows!.length; i++) {
	// 	const row = mappingStore.templateData!.rows![i];
	// 	for (let j = 0; j < row.cellTuples.length; j++) {
	// 		const cell = row.cellTuples[j];
	// 		if (cell.meta?.selectables && cell.meta?.selectables.length > 0) {
	// 			logDebug("cell", cell.meta.id, cell.meta.selectables);
	// 		}
	// 	}
	// }

	return (
		<div id="pdf-contained" className="overflow-y-auto h-full relative">
			<div id="clone-btn" className="absolute bg-red-100 right-4 top-4 p-2 btn" onClick={onClose}>
				X
			</div>
			<div
				id="pdf-btn"
				className="absolute bg-red-100 right-16 top-4 p-2 btn"
				onClick={async () => {
					const pdfBtn = document.getElementById("pdf-btn");
					const cloneBtn = document.getElementById("clone-btn");
					pdfBtn && (pdfBtn.style.display = "none");
					cloneBtn && (cloneBtn.style.display = "none");
					const container = document.getElementById("pdf-contained")!;
					setExportingPDF(true);

					await exportPDFElements([container], { outname: "test-data", orientation: "portrait" });
					setExportingPDF(false);

					pdfBtn && (pdfBtn.style.display = "block");
					cloneBtn && (cloneBtn.style.display = "block");
				}}
			>
				Save as pdf
			</div>
			<img src={`template_${type}.png`}></img>
			{renderedList.map((item, index) => {
				if (item.s === "~") {
					return (
						<div
							key={index}
							className="absolute border-2 border-black rounded-2xl"
							style={{
								top: item.top - 2,
								left: item.left - 2,
								width: item.width + 4,
								height: item.height + 4,
							}}
						></div>
					);
				} else {
					return (
						<div
							key={index}
							className="absolute flex justify-end px-3 py-0.5 "
							style={{
								fontSize: "30px",
								fontWeight: "bold",
								fontFamily: "Indie Flower",
								top: item.top - (exportingPDF ? item.height / 2 : 0),
								left: item.left,
								width: item.width,
								height: item.height,
							}}
						>
							{item.s}
						</div>
					);
				}
			})}
		</div>
	);
});

const CreateTestData: React.FC = observer(() => {
	const mappingStore = getMappingStore();
	const mappingToolStore = getMappingToolStore();
	const [selectedTupple, setSelectedTupple] = useState<TemplateCellTuple>();
	const [showSampleTic, setShowSampleTic] = useState(false);
	const [selectValue, setSelectValue] = useState(0);
	const [currentType, setCurrentType] = useState("Type1");
	useEffect(() => {
		mappingToolStore.ticType = currentType;
		mappingStore.loadData(false, false, currentType);
	}, [currentType]);
	useEffect(() => {
		if (mappingStore.templateData && mappingStore.templateData.rows && mappingToolStore.selectedTuple[0] > -1) {
			const selected =
				mappingStore.templateData.rows[mappingToolStore.selectedTuple[0]].cellTuples[mappingToolStore.selectedTuple[1]]!;
			setSelectedTupple(selected);
		} else {
			setSelectedTupple(undefined);
		}
	}, [mappingToolStore.selectedTuple]);

	return (
		<div>
			<MappingTopBox />
			<MappingTicTypeSelector onSelect={(type) => setCurrentType(type)} />
			<div className="h-8"></div>

			<div className="flex">
				<select
					className="border m-1"
					value={selectValue}
					onChange={(e) => {
						setSelectValue(parseInt(e.target.value));
					}}
				>
					{[
						EUseIndex.ErrorOnly,
						EUseIndex.Last,
						EUseIndex.Random,
						EUseIndex.First,
						...Array(5)
							.fill(0)
							.map((_, i) => i + 1),
					].map((index) => {
						return (
							<option key={index} value={index}>
								{index === EUseIndex.First && "First"}
								{index === EUseIndex.Random && "Random"}
								{index === EUseIndex.Last && "Last"}
								{index === EUseIndex.ErrorOnly && "Error Only"}
								{index > 0 && index}
							</option>
						);
					})}
				</select>
				<button
					onClick={() => {
						setShowSampleTic(!showSampleTic);
					}}
				>
					Show Sample Tic
				</button>
			</div>
			{showSampleTic && (
				<TopMostPortal>
					<TicSheetTableFilled
						key={currentType}
						type={currentType}
						useIndex={selectValue}
						onClose={() => setShowSampleTic(false)}
					/>
				</TopMostPortal>
			)}
			<MappingTicSheetTable
				overrideRenderingProps={{
					showHeatmapData: false,
					showSelectables: false,
					showHasMapping: false,
				}}
			/>
			{selectedTupple && (
				<TopMostPortal>
					<TestDataTable key={currentType} type={currentType} selectedTupple={selectedTupple} />
				</TopMostPortal>
			)}
			{mappingStore.loadingData && <LoadingAnimation fullScreen={mappingStore.loadingDataBlocking} />}
		</div>
	);
});

export default CreateTestData;
